export default () => ({
  errors: {},
  show: false,
  showModal: false,
  isDisabled: false,
  isPassword: false,
  showModalAccountDisabled: false,
  showModalPassword: false,
  sexOptions: [
    {id: 'male', label: 'Masculino'},
    {id: 'female', label: 'Feminino'}
  ],
  profile: {
    id: null,
    entity_id: null,
    responsable_id: null,
    name: null,
    email: null,
    password: null,
    type: null,
    birthdate: null,
    genre: null,
    phones: {
      mobile: null,
      home: null,
      work: null
    },
    social: null,
    avatar: null,
    sms: true,
    country_register: null,
    state: null,
    active: null,

    // Agenda de professinais
    schedule_block: null,

    // Remover professional
    document: null,
    record: null,
    networks: null,
    bio: null
  }
})



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/data.js